import useIsInSoftNotifyExperiment from '~/hooks/vdp/useInSoftNotifyExperiment';
import useHasVehicleNotifyStatus from './useHasVehicleNotifyStatus';

export default function useShouldShowStatusDataForExperiment() {
  const isInSoftNotifyExperiment = useIsInSoftNotifyExperiment();
  const shouldShowStatusBanner = useHasVehicleNotifyStatus();

  return isInSoftNotifyExperiment && shouldShowStatusBanner;
}
